module.exports = __webpack_public_path__ + "static/index/img/baikal-206.8041862d.jpg";